import cx from "classnames";
import { type PropsWithChildren, type ReactElement } from "react";

import { ExternalHeader } from "components/external-header";
import { PublicHeader } from "components/public-header";
import { PageFooter } from "components/shared/page-footer";

import styles from "./unauth-layout.module.scss";

type UnauthLayoutProps = PropsWithChildren<{
  size?: "lg" | "md";
  headerElement?: ReactElement;
  hideNav?: boolean;
}>;

const UnauthLayout = ({
  children,
  size = "md",
  hideNav,
}: UnauthLayoutProps) => {
  return (
    <>
      <ExternalHeader returnUrlParsed />
      <PublicHeader hideNav={hideNav} />
      <div className={styles.unauthLayoutWrapper}>
        <div
          className={cx(
            styles.unauthLayoutContent,
            size === "lg" ? styles.large : null
          )}
        >
          {children}
        </div>
      </div>
      <PageFooter unauthenticated />
    </>
  );
};

export default UnauthLayout;
